import axiosInstance from "./axiosInstance";

const scannedItemsService = {
  create: async (payload) => {
    try {
      const response = await axiosInstance.post('/warehouseproducts/create', payload);
      return response.data;
    } catch (error) {
      // Safe error handling
      const message =
        error?.response?.data?.message ||
        error?.response?.data ||
        error?.message ||
        "Unknown error while creating scanned item.";
      throw new Error(message);
    }
  },

  fetchAll: async () => {
    try {
      const response = await axiosInstance.get('/warehouseproducts/all');
      return response.data;
    } catch (error) {
      const message =
        error?.response?.data?.message ||
        error?.response?.data ||
        error?.message ||
        "Unknown error fetching items.";
      throw new Error(message);
    }
  },

  fetchByData: async (id) => {
    try {
      const response = await axiosInstance.get(`/warehouseproducts/bydata/${id}`);
      return response.data;
    } catch (error) {
      const message =
        error?.response?.data?.message ||
        error?.response?.data ||
        error?.message ||
        "Unknown error fetching item0.";
      throw new Error(message);
    }
  },


  delete: async (id) => {
    try {
      const response = await axiosInstance.delete(`/warehouseproducts/delete/${id}`);
      return response.data;
    } catch (error) {
      const message =
        error?.response?.data?.message ||
        error?.response?.data ||
        error?.message ||
        "Unknown error deleting item.";
      throw new Error(message);
    }
  },

  update: async (id, payload) => {
    try {
      const response = await axiosInstance.put(`/warehouseproducts/update/${id}`, payload);
      return response.data;
    } catch (error) {
      const message =
        error?.response?.data?.message ||
        error?.response?.data ||
        error?.message ||
        "Unknown error updating item.";
      throw new Error(message);
    }
  },
};

export default scannedItemsService;
